import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState, useImperativeHandle, forwardRef } from 'react';
import { Prompt } from 'react-router-dom';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

// Add ref to allow programmatic triggering
export var FormPrompt = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var hasUnsavedChanges = _ref.hasUnsavedChanges,
    formPromptTitle = _ref.formPromptTitle,
    formPromptMessage = _ref.formPromptMessage,
    formPromptCancel = _ref.formPromptCancel,
    formPromptOk = _ref.formPromptOk,
    currentPathContext = _ref.currentPathContext;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showDialog = _useState2[0],
    setShowDialog = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    confirmedNavigation = _useState4[0],
    setConfirmedNavigation = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    nextLocation = _useState6[0],
    setNextLocation = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    resolvePromise = _useState8[0],
    setResolvePromise = _useState8[1];

  // Handle browser back/forward buttons and page refresh
  useEffect(function () {
    var handleBeforeUnload = function handleBeforeUnload(e) {
      if (hasUnsavedChanges && !confirmedNavigation) {
        e.preventDefault();
        e.returnValue = '';
        return '';
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return function () {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [hasUnsavedChanges, confirmedNavigation]);
  var handleBlockedNavigation = function handleBlockedNavigation(location) {
    if (!confirmedNavigation && hasUnsavedChanges) {
      setShowDialog(true);
      setNextLocation(location);
      return false;
    }
    return true;
  };

  // Expose showPrompt for programmatic use (returns a Promise)
  useImperativeHandle(ref, function () {
    return {
      showPrompt: function showPrompt() {
        return new Promise(function (resolve) {
          setShowDialog(true);
          setNextLocation(null);
          setResolvePromise(function () {
            return resolve;
          });
        });
      }
    };
  }, []);
  var handleConfirmNavigationClick = function handleConfirmNavigationClick() {
    setShowDialog(false);
    setConfirmedNavigation(true);
    if (resolvePromise) {
      resolvePromise(true);
      setResolvePromise(null);
    }
    // Navigate to the next location if navigation event
    if (nextLocation) {
      setTimeout(function () {
        window.location.href = nextLocation.pathname;
      }, 0);
    }
  };
  var handleCancelNavigationClick = function handleCancelNavigationClick() {
    setShowDialog(false);
    setNextLocation(null);
    if (resolvePromise) {
      resolvePromise(false);
      setResolvePromise(null);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Prompt, {
    when: hasUnsavedChanges,
    message: handleBlockedNavigation
  }), /*#__PURE__*/React.createElement(Dialog, {
    open: showDialog,
    onClose: handleCancelNavigationClick
  }, /*#__PURE__*/React.createElement(DialogTitle, null, formPromptTitle), /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement(DialogContentText, null, formPromptMessage)), /*#__PURE__*/React.createElement(DialogActions, null, /*#__PURE__*/React.createElement(Button, {
    onClick: handleCancelNavigationClick,
    color: "primary"
  }, formPromptCancel), /*#__PURE__*/React.createElement(Button, {
    onClick: handleConfirmNavigationClick,
    color: "primary",
    variant: "contained"
  }, formPromptOk))));
});